import { useMemo } from 'react';
import styles from './index.module.scss';

export default function LiveStatusLabel () {
  const isActive = useMemo(() => {
    try {
      return Boolean(globalThis.gazeta_pl.RTC_V2.isLive);
    } catch {
      return false;
    }
  }, []);
  const isActiveLabel = useMemo(() => isActive ? 'Trwa' : 'Zakończona', [isActive]);

  return (
    <div
      className={styles['live-status-label']}
      data-active={isActive}
      data-e='notes-status'
    >
      {isActiveLabel}
    </div>
  );
}
